import React, { useEffect, useState } from 'react';
import '../../assets/css/popupAddCombination.css'
import {
    Container,
    Modal,

    Row,
    Form
} from "react-bootstrap";
import './popup.css';
import api from "../../seller-apis/api";
import { useAlert } from 'react-alert';
import variables from '../../Variables.json'
import { inputValidations } from '../../Validations/Inputs';
let finalCombVals = [];
const ActionRequiredConfirmModalComb = ({ details, callBack, curProp, closeModal, handleReject }) => {
    const alert = useAlert();
    const [price, setPrice] = useState("");
    const [stock, setStock] = useState("");
    const [gst, setGst] = useState("Select Gst");
    // Toast States
    const [gstToastMsg, setGstToastMsg] = useState("");
    const [stockToastMsg, setStockToastMsg] = useState("");
    const [hsnToastMsg, setHsnToastMsg] = useState("")
    // Combination handling
    const [curComurl, setcurComurl] = useState(undefined);
    const [combinations, setCombinations] = useState([])
    const [callbackMsg, setCallBackMsg] = useState(null)
    const [viewMore, setViewMore] = useState(false);
    const [showHsnGstModal, setShowHsnGstModal] = useState(true)
    const [hsn, setHsn] = useState("")
    const [hsnDisabled, setHsnDisabled] = useState(true)
    const [verTrPrice, setVerTrPrice] = useState(null)


    const handleClose = (cmd) => {
        resetValues()
        closeModal();
    };


    useEffect(() => {
        finalCombVals = [];
        setCallBackMsg(null)
        if (details?.combination?.length > 0) {
            let productCombinations = details?.combination;
            let vendor = details?.vendor;
            let combarry = [];
            let singleAttr = true;
            let combAttribs = [];
            if (
                productCombinations[0].value.length > 1
            ) {
                singleAttr = false;
            }
            combAttribs = productCombinations[0].value;
            productCombinations.map((pitem, pindex) => {
                if (pitem.active) {
                    let combVals = {}
                    if (!singleAttr) {
                        let com = "";
                        pitem.value.forEach((aitem, aindex) => {
                            com += combAttribs[aindex] + " - " + aitem;
                            com += aindex === pitem.value.length - 1 ? "" : ", ";
                        });
                        combVals = {
                            com: com,
                            price: "",
                            url: pitem.url,
                            tmpSts: pitem.tmpSts,
                            stock: ""
                        }
                    } else {
                        combVals = {
                            com: combAttribs[0] + " - " + pitem.value[0],
                            price: "",
                            url: pitem.url,
                            tmpSts: pitem.tmpSts,
                            stock: ""
                        };
                    }
                    const foundVendorComb = vendor?.combination?.filter((item) => item.url === pitem.url)
                    console.log("foundVendorComb", foundVendorComb)
                    if (foundVendorComb?.length > 0) {
                        combVals["price"] = foundVendorComb[0]?.purchase_price;
                        combVals["stock"] = foundVendorComb[0]?.stock;
                    }
                    if (combarry.length === 0) {
                        setcurComurl(pitem?.url);
                        setPrice(foundVendorComb[0]?.purchase_price);
                        setStock(foundVendorComb[0]?.stock);
                        setGst(details?.vendor?.taxClass || "Select Gst")
                    }
                    combarry.push(combVals)
                }
            })
            setCombinations(combarry)
        }
    }, [])

    const addProduct = async () => {
        setGstToastMsg("");
        setStockToastMsg("");
        const isValid = validation();

        if (!isValid) return;

        let data;
        // if (details?.vendor?.taxClass == gst) {

        //     data = {
        //         _id: details.lead,
        //         purchase_price: price,
        //     };
        // } else {

        //     data = {
        //         _id: details.lead,
        //         purchase_price: price,
        //         taxClass: gst,
        //     };
        // }
        // if (props.flag === "TV Catalogue") {
        //     data['receivedFrom'] = "tv_catalog";
        // }
        // let combination = {};
        // combination["url"] = curComurl;
        // combination["stock"] = Number(stock)
        // delete data["purchase_price"];
        // data["combination"] = combination;
        let updatedComb = {
            url: curComurl,
            gst: gst,
            stock: Number(stock)
        }
        finalCombVals.push(updatedComb);
        try {
            // const res = await api.product.addToExProduct(data);
            handleSuccessfulSubmit()
        } catch (error) {
            console.log("Error in addProduct", error);
            alert.error("Error in adding product");
        }
    }

    const handleSuccessfulSubmit = () => {
        // alert.success("Combination added successfully");
        // setCallBackMsg("product added")
        console.log(finalCombVals)
        let updatedCombinations = combinations.filter((item) => item.url !== curComurl);
        setCombinations(updatedCombinations);
        handleCombinationChange(updatedCombinations?.[0])
        if (updatedCombinations?.length === 0) {
            handleClose("reload")
            finalUpdateAndSubmit()
        }
    }

    const finalUpdateAndSubmit = async () => {
        let combination = [];
        let data = {};
        data["_id"] = details?.product?._id;
        finalCombVals.map(async (item, index) => {
            let actualComb = details?.vendor?.combination?.find((combItem) => combItem.url === item?.url)
            if (Number(item?.stock) !== Number(actualComb?.stock)) {
                let record = {
                    url: item?.url,
                    stock: item?.stock
                }
                combination.push(record)
            }
            if (index === 0 && Number(gst) !== Number(details?.vendor?.taxClass)) {
                data['taxClass'] = gst
            }
            if (index === 0 && Number(hsn) !== Number(details?.vendor?.HSN)) {
                data['HSN'] = hsn
            }
        })
        try {
            data["combination"] = combination
            const res = await api.product.bulkAddToExProduct(data);
            callBack("approve", curProp)
        }
        catch (error) {
            console.log("Error in finalUpdateAndSubmit", error);
            alert.error("Some error occured.")
        }
    }

    const checkMinusInput = (e) => {
        if (e.code === "Minus") {
            e.preventDefault();
        }
    }

    const changeGST = (e) => {
        setGst(e.value);
    };

    const validation = () => {
        let isValid = true
        if (gst === "" || gst === undefined || gst === null || gst === "Select Gst") {
            isValid = false;
            setGstToastMsg(" Please enter a valid GST");
        }
        if (!gstValidationNum(gst)) {
            setGstToastMsg("Please select a valid gst option from 0, 5 or 18")
            return false;
        }

        if (stock === undefined || stock === "0" || stock === 0 || stock < 1 || String(stock).includes(".") || String(stock).trim() === "") {
            isValid = false
            setStockToastMsg(" Please enter a valid stock count");
        }
        return isValid
    }

    // Handle Combination Change
    const handleCombinationChange = (item) => {
        setGstToastMsg("")
        setStockToastMsg("")
        setPrice(item?.price || "")
        setStock(item?.stock || "")
        setcurComurl(item?.url)
    }

    const resetValues = () => {
        setGstToastMsg("")
        setStockToastMsg("")
        setPrice(null)
        setStock(null)
        setcurComurl(null)
    }


    const gstValidationNum = (gst) => {
        if(Number(gst) === 0 || Number(gst) === 5 || Number(gst) === 18){
            return true
        }
        return false
    }

    const handleGstHsnSubmit = () => {
        setGstToastMsg("")
        setHsnToastMsg("")
        if (gst === "Select Gst" || gst === undefined || gst === null || gst === "") {
            setGstToastMsg("Please select a valid gst option.")
            return false;
        }
        if (!gstValidationNum(gst)) {
            setGstToastMsg("Please select a valid gst option from 0, 5 or 18")
            return false;
        }
        if (hsn !== undefined && hsn !== null && hsn !== "") {
            let hsnOutput = inputValidations.hsn(hsn)
            if (hsnOutput?.status === false) {
                setHsnToastMsg(hsnOutput?.msg)
                return false
            }

        }
        setShowHsnGstModal(false)
    }

    const styles = {
        verifyManifestPopup: {
            headerDiv: {
                display: 'flex',
                width: '100%'
            },
            expTraPriceTag: {
                // background: 'red',
                // width: 'fit-content',
                margin: 'auto',
                // padding: '2px 20px',
                color: 'red',
                // marginBottom: '13px'

            },
            headerBtns: {
                flex: 1,
                border: 'none',
                boxShadow: '0px 1px 0px 0.5px grey',
                padding: '4px 0px',
                fontSize: "14px"
            },
            vtpPara: {
                textAlign: 'left',
                fontSize: '16px',
                fontWeight: "bold",
                padding:"0px 0px 10px 0px"
            },
            imageBox: {
                height: "98px"
            },
            pName: {
                textAlign: 'left',
                fontSize: '16px',
                color: '#165b5b'
            },
            sku: {
                textAlign: 'left',
            },
            confirmBtn: {

            },
            label: {
                display: 'flex',
                justifyContent: 'center'
            },
            tpInput: {
                width: "100px",
                padding: '2px 23px 2px 11%',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
            },
            gstInput: {
                fontSize: "10px",
                padding: "2px 10px",
                width: "100px"
            },
            rsLabel: {
                position: 'absolute',
                top: '3px',
                left: '2%',
                // fontWeight:'800 !important'
            },
            tpTitle: {
                color: 'black',
                // sl-758
                width: '40%',
                textAlign: 'right'
            },
            sUpdateContainer: {
                // width: '50%',
                width: '30%',
                textAlign: 'left',
            },
            cStockTitle: {
                position: 'absolute',
                transform: 'translateY(-50%)',
                top: '0px',
                marginLeft: '12px',
                zIndex: 1,
                padding: '0px 4px',
                background: 'white',
            },
            cStockInput: {
                width: "100px",
                padding: '2px 23px 2px 2%',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
            },
            endBtnContainer: {
                textAlign: 'end',
                marginTop: '40px'
            },
            submitBtn: {
                color: '#fff',
                background: '#165b5b',
                borderRadius: '4px',
                padding: "4px 20px",
                borderStyle: 'none',
                fontSize: '15px',
                boxShadow: '0 .2em 1em -.2em #d0d0d0'
            },
            backBtn: {
                color: 'white',
                background: '#909090',
                borderRadius: '4px',
                padding: "4px 15px",
                borderStyle: 'none',
                fontSize: '15px',
                boxShadow: '0 .2em 1em -.2em #d0d0d0',
                marginRight: '4px'
            },
            rejectBtn: {
                color: 'black',
                background: '#FFADB0',
                borderRadius: '4px',
                padding: "4px 15px",
                borderStyle: 'none',
                fontSize: '15px',
                boxShadow: '0 .2em 1em -.2em #d0d0d0',
                marginRight: '4px'
            },
            tpEdit: {
                top: '3px',
                position: 'absolute',
                right: '110px',
                cursor: 'pointer'
            },
            stockEdit: {
                top: '3px',
                position: 'absolute',
                right: '127px',
                cursor: 'pointer'
            },
            hsnInput: {
                width: "100px",
                padding: '2px 2% 2px 2%',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
            },
            hsnEdit: {
                top: '3px',
                position: 'absolute',
                right: '127px',
                cursor: 'pointer'
            },
        }
    }

    const ModalHeader = () =>
    (
        <>
            <div className="w-30">
                <div
                    className="catalog-img-border"
                    style={{
                        background: `url(

                    "https://s3.toolsvilla.com/${curProp?.image}"

                  )`,
                    }}
                >
                </div>
            </div>
            <div className="w-70 align-self-start mt-2">
                <p className="product-name ff_pop d-flex justify-contain-start" style={{fontWeight:"600"}}>{details?.productName}</p>
                <p className="sku mb-2 d-flex justify-contain-start">SKU - {details?.SKU}</p>
                {/* <h6 className="product-name ff_pop fw-bold d-flex justify-contain-start">Brand Name</h6> */}
                <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: details?.shortDescription }}></div>
                </div>
                {viewMore && <div style={{ textAlign: 'left' }}><p className="fs-13">Description</p>
                    <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: details?.description }}></div>
                </div>}
                <p style={{ cursor: "pointer", fontSize: "12px", color: "blue" }} onClick={() => setViewMore(!viewMore)}>{viewMore ? "View Less" : "View More"}</p>
            </div>
        </>
    )


    return (
        <Modal
            show={true}
            onHide={handleClose}
            className='popupCombinationModal'
            centered
        >
            <a class="close mt-1" onClick={() => {
                handleClose()
            }}>
                &times;
            </a>
            <Modal.Body className=" p_3px">
                <>
                        <p style={styles.verifyManifestPopup.vtpPara}>{showHsnGstModal?"Confirm GST and HSN":"Confirm Price and Stock"}</p>
                    <div className="d-flex header">
                        <ModalHeader />
                    </div>

                    {!showHsnGstModal && <>
                        <div className='d-flex mt-2'>

                            {/* Combination list */}
                            <div className='w-30 combination-list'>
                                <ul>
                                    {combinations.map((item, index) => {
                                        return (
                                            <li key={index} className={curComurl === item?.url ? 'active' : ""}>{item.com}</li>
                                        )
                                    })}
                                </ul>

                            </div>

                            {/* Form */}
                            <div className='w-70 input-area'>
                                <Row className="text-center mt-1">
                                    <div className="fw-bold d-flex justify-contain-start">Add Price</div>
                                    <div className="col-12 ">
                                        <form className="">
                                            <label className="transfer-price-container">
                                                <p className="transfer-price ff_pop my-auto">
                                                    Transfer Price (incl. {gst}% GST) :
                                                </p>
                                                <p className="position-relative">
                                                    <input
                                                        type="number"
                                                        name="number"
                                                        autocomplete="off"
                                                        minLength="1"
                                                        onKeyDown={checkMinusInput}
                                                        value={price}
                                                        required
                                                        disabled={true}
                                                        onChange={(e) => setPrice(e.target.value)}
                                                        onWheel={(e) => e.target.blur()}
                                                        className=" w-100 input-with-label"
                                                    />
                                                    <span class="rs-label">Rs</span>

                                                </p>
                                            </label>

                                        </form>
                                    </div>
                                </Row>
                                <hr />

                                <Row className="text-center mt-1">
                                    <div className="fw-bold d-flex justify-contain-start">Add Stock</div>
                                    <div className="col-12 ">
                                        <form className="">
                                            <label className="transfer-price-container">
                                                <p className="transfer-price ff_pop my-auto">
                                                    <span className='text-red'>*</span>Stock

                                                </p>
                                                <p className="position-relative">
                                                    <input
                                                        type="number"
                                                        value={stock}
                                                        name="number"
                                                        autocomplete="off"
                                                        minLength="1"
                                                        onKeyDown={checkMinusInput}
                                                        required
                                                        onChange={(e) => setStock(e.target.value)}
                                                        onWheel={(e) => e.target.blur()}
                                                        className=" w-100 input-without-label"
                                                    />


                                                </p>
                                            </label>
                                            {stockToastMsg !== "" && <div
                                                className="toastAlert"
                                            >

                                                {stockToastMsg}.
                                            </div>}
                                        </form>
                                    </div>
                                </Row>

                                <div className="justify-content-end d-flex-responsive">

                                    <button
                                        className="submit-btn"
                                        onClick={() => addProduct()}
                                    >
                                        SUBMIT
                                    </button>

                                </div>
                            </div>
                        </div>
                    </>
                    }
                </>
                {
                    showHsnGstModal && <>
                        <>
                            <Row className="text-center mt-1">
                                <div className="col-12 ">
                                    {/* <div style={styles.verifyManifestPopup.expTraPriceTag}>
                                    Expected Transfer Price : <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceFrom)} - <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceTo)}
                                </div> */}
                                    <form className="">
                                        <label style={styles.verifyManifestPopup.label}>
                                            <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                                <span className='text-red'>*</span>Select Gst % :
                                            </span>
                                            <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>

                                                <select
                                                    size="sm"
                                                    style={styles.verifyManifestPopup.gstInput}
                                                    value={gst}
                                                    onChange={(e) => changeGST(e.target)}
                                                >
                                                    <option value="Select Gst">Select Gst</option>
                                                    {variables?.variables?.gstValues.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item}>
                                                                {item}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </span>
                                        </label>
                                        <div className=''>
                                            <label style={styles.verifyManifestPopup.label}>
                                                <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                                                    HSN :
                                                </span>

                                                <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                                                    <input
                                                        type="number"
                                                        autocomplete="off"
                                                        minLength="1"
                                                        value={hsn}
                                                        style={styles.verifyManifestPopup.hsnInput}
                                                        required
                                                        // disabled={hsnDisabled}
                                                        onChange={(e) => setHsn(e.target.value)}
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    {/* <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span> */}
                                                    {/* <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setHsnDisabled(false)}></i></span> */}
                                                </span>
                                            </label>
                                            <br />
                                            {hsnToastMsg !== "" && <div
                                                className="toastAlert2 mb-2"
                                            >
                                                {hsnToastMsg}
                                            </div>}
                                            {gstToastMsg !== "" && <div
                                                className="toastAlert2 mb-2"
                                            >

                                                {gstToastMsg}
                                            </div>}
                                        </div>

                                    </form>
                                </div>
                            </Row>
                            <p style={styles.verifyManifestPopup.endBtnContainer}>
                                <button style={styles.verifyManifestPopup.rejectBtn} onClick={() => handleReject(curProp)}>Reject</button>

                                <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => handleGstHsnSubmit()}>Confirm and Proceed</button>
                            </p>
                        </>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ActionRequiredConfirmModalComb;